import { encodeInt, getHashesWithinBboxInt } from "geohashing";

// https://github.com/arseny034/geohashing?tab=readme-ov-file#usage

// this control how large the squares on the map, bigger number, smaller squares
const bitDepth = 14;

/*
bitDepth => hashes to cover all of iceland
8  => 2
10 => 3
12 => 12
14 => 44
16 => 160
*/

type Point = { lat: number; lng: number };

// these functions are lightning fast, <1ms per call

/** Translate lat/lng to geohash */
export const getHashForPoint = (point: Point) =>
  encodeInt(point.lat, point.lng, bitDepth);

/** Translate min/max lat/lng to list of geohashes */
export const getHashesForArea = (min: Point, max: Point) => {
  let hashes: number[];
  if (max.lng < min.lng) {
    // we've crossed the edge of the world, glue two sets together
    hashes = [
      ...getHashesWithinBboxInt(min.lat, min.lng, max.lat, 180, bitDepth),
      ...getHashesWithinBboxInt(min.lat, 180, max.lat, max.lng, bitDepth),
    ];
  } else {
    hashes = getHashesWithinBboxInt(
      min.lat,
      min.lng,
      max.lat,
      max.lng,
      bitDepth,
    );
  }
  return hashes;
};
